module.exports = __webpack_public_path__ + "img/ad.adaa31ee0.svg";